import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { auth, googleProvider, signInWithRedirect } from '../firebase';
import './LoginPage.css';

function LoginPage() {
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      await signInWithRedirect(auth, googleProvider);
      // Note: The redirect will happen automatically, no need to navigate
    } catch (error) {
      console.error('Error signing in with Google:', error);
    }
  };

  return (
    <div>
      <Navigation hideLogin={true} />
      <div className="login-container">
        <div className="login-content">
          <h1 className="login-title">Welcome Back, Girly</h1>
          <p className="login-subtitle">Sign in to access your personalized fertility roadmap</p>
          
          <button onClick={handleGoogleSignIn} className="google-signin-button">
            <img 
              src="/google-icon.svg" 
              alt="Google" 
              className="google-icon"
            />
            Continue with Google
          </button>

          <p className="login-disclaimer">
            By continuing, you agree to our Terms of Service and Privacy Policy
          </p>

          <p className="login-signup-link">
            Don't have an account? <Link to="/signup">Sign up</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage; 